export default {
  setGames (state, payload) {
    state.list = payload
  }
}